/*
 *
 * Form
 *
 */

import { useEffect } from "react";
import { Link } from "react-router-dom";
import { colors } from "globalStyles";
import { ButtonGroup } from "./styledComponents";
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "components/Button";
import InputField from "components/InputField";
import Loader from "components/Loader";
import { Controller, useForm, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import * as yup from "yup";
import { t } from "copy/t";
import { resetForm, signInRequest } from "./actions";

const schema = yup
  .object({
    email: yup.string().email('Please enter a valid email address').required('Email is required'),
    password: yup.string().required('Password is required'),
  })
  .required();

const SignInForm = ({ initialValues }) => {
  const dispatch = useDispatch();

  const shouldReset = useSelector((state) => state.signIn.resetForm);

  const { control, handleSubmit, setValue, reset, getValues, formState, trigger } =
    useForm({
      resolver: yupResolver(schema),
      mode: "onChange",
      // shouldUseNativeValidation: false,
      defaultValues: {
        email: "" || initialValues.email,
        password: "" || initialValues.password,
      },
    });
  

  const { errors, isSubmitting, isSubmitted } = formState;

  useEffect(() => {
    if (initialValues) {
      Object.keys(initialValues).map((name) => {
        setValue(name, initialValues[name]);
      });
    }
  }, []);
  const isError = errors && (errors.email || errors.password) ? true : false;

  useEffect(() => {
    if (shouldReset) {
      const values = getValues();
      reset(values, { isSubmitted: false, isSubmitting: false });
    }
  }, [shouldReset]);

  const onSignInSubmit = (data) => {
    if (formState.isValid) {
      dispatch(signInRequest(data));
    } else if (errors.email) {
      toast.error(t("toast.invalidEmail"));
    }
  };

  const submitDisabled = isSubmitted || isSubmitting || !formState.isValid;

  return (
    <div className="mb-[50px] flex flex-col gap-0 mt-[16px]" key={"for"}>
      <form>
        <Controller
          control={control}
          name="email"
          render={({ field: { ref, ...fieldRest } }) => (
            <InputField
              name="email"
              type="text"
              label="Email Address"
              placeholder={t("placeholders.email")}
              field={fieldRest}
              errorMsg={errors?.email?.message}
            />
          )}
        />
        <Controller
          control={control}
          name="password"
          render={({ field: { ref, ...fieldRest } }) => (
            <InputField
              name="password"
              type="password"
              label="Password"
              errorMsg={errors?.password?.message}
              placeholder={t("placeholders.enterPassword")}
              showPasswordButton={false}
              field={fieldRest}
            />
          )}
        />
        <div className="text-right mb-4">
          <Link
            to="/forgot-password"
            className="text-sm"
            style={{ color: colors.MAIN_COLOR }}
          >
            forgot your password?
          </Link>
        </div>
        <ButtonGroup>
          <Button
            type={isError ? "button" : "submit"}
            disabled={submitDisabled}
            onClick={handleSubmit(onSignInSubmit)
            }
          >
            {isSubmitted || isSubmitting ? <Loader /> : "Sign In"}
          </Button>
        </ButtonGroup>
      </form>
    </div>
  );
};

export default SignInForm;
